export default function unmask(str: any, preserveChars: string[] = []): string {
  return String(str)
    .split('')
    .reduce((acc, char) => {
      if (!/^\d+$/.test(char) && !preserveChars.includes(char)) return acc;

      return acc + char;
    }, '');
}
